import React from 'react';
import { Link } from 'react-router-dom';
import { isEnglish } from '../i18n/locale';
import LanguageControl from '../i18n/LanguageControl';
import usePageMetadata from '../hooks/usePageMetadata';
import { JIKEYIXIA } from '../data/jikeyixia';
import policy from '../data/jikeyixiaPrivacy.json';
import icon from '../assets/jikeyixia-icon.svg';
import '../styles/jikeyixia-privacy.css';

function PolicyText({ text }) {
  const parts = text.split(JIKEYIXIA.supportEmail);
  return <>{parts.map((part, index) => <React.Fragment key={index}>{index > 0 && <a href={`mailto:${JIKEYIXIA.supportEmail}`}>{JIKEYIXIA.supportEmail}</a>}{part}</React.Fragment>)}</>;
}

export default function JikeYixiaPrivacy() {
  const copy = isEnglish ? policy.en : policy.zh;
  usePageMetadata(`${copy.title} · PeaceTech`, copy.description, JIKEYIXIA.privacyPath);
  return <div className="privacy-container jikeyixia-privacy">
    <header className="privacy-header">
      <div className="app-info">
        <div className="app-icon"><img src={icon} alt="" /></div>
        <div className="app-details">
          <h1>{isEnglish ? JIKEYIXIA.name.en : JIKEYIXIA.name.zh}</h1>
          <p>{isEnglish ? 'Privacy Policy' : '隐私政策'}</p>
        </div>
      </div>
      <div className="policy-header-actions">
        <Link to="/" className="back-link">{isEnglish ? '← Back to Home' : '← 返回首页'}</Link>
        <LanguageControl />
      </div>
    </header>
    <main className="privacy-content" id="jike-policy-content">
      <div className="privacy-section">
        <p>{isEnglish ? 'Effective date' : '生效日期'}: <time dateTime={copy.effectiveDate}>{copy.effectiveDate}</time></p>
        <p>{copy.intro}</p>
        <nav className="policy-related-links" aria-label={isEnglish ? 'Related pages' : '相关页面'}>
          <Link to="/privacy">{isEnglish ? 'All privacy policies' : '全部隐私政策'}</Link>
          <Link to={JIKEYIXIA.path}>{isEnglish ? 'Product page' : '产品介绍'}</Link>
        </nav>
      </div>
      <nav className="policy-contents" aria-label={isEnglish ? 'Policy sections' : '政策目录'}>
        {copy.sections.map(section => <a key={section.id} href={`#${section.id}`}>{section.title}</a>)}
      </nav>
      {copy.sections.map(section => <section className="privacy-section" key={section.id} id={section.id}>
        <h2>{section.title}</h2>
        {section.paragraphs.map((text, index) => <p key={index}><PolicyText text={text} /></p>)}
        {section.bullets.length > 0 && <ul className="policy-bullets">
          {section.bullets.map((text, index) => <li key={index}><PolicyText text={text} /></li>)}
        </ul>}
      </section>)}
    </main>
  </div>;
}
